<template>
    <section class="menu-view">
        <HeaderComponent :title="'Cardápio'" />
        <div class="menu-container">
            <h1>{{ currentRestaurant.NMFILIAL }}</h1>

            <div class="search">
                <input type="text" placeholder="Buscar" v-model="searchText" @input="filterItems" />
                <i class="fa fa-search icon"></i>
            </div>

            <div class="list" v-if="this.groups.length > 0">
                <div class="groups" v-for="(item, key) in groups" :key="key">
                    <div class="list-item" @click="item.showProducts = !item.showProducts" v-if="item.isVisible">
                        <div class="list-item-field">
                            <h1 v-text="item.DSBUTTON"></h1>
                        </div>
                        <div class="list-item-field">
                            <i :class="item.showProducts ? 'fa fa-chevron-down icon' : 'fa fa-chevron-right icon'"></i>
                        </div>
                    </div>

                    <transition name="slide-fade">
                        <div class="wrapper" v-if="item.showProducts">
                            <div v-if="loading" class="loading">
                                <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                            </div>
                            <div v-else-if="item.products.length > 0" class="products" v-for="(product, key) in item.products" :key="key" @click="handleProductClick(product)">
                                <h1 v-text="product.NMPRODUTO"></h1>
                                <h1 v-text="product.VRPRECITEM.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })"></h1>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>

            <div class="not-found" v-else>
                <h1>Nenhum item encontrado</h1>
            </div>

        </div>

        <ProductModal />
        <ProductGroupComponent />
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import ProductModal from '../../components/modals/ProductModal.vue'
import ProductGroupComponent from '@/components/bottom-popups/ProductGroupComponent.vue'
import { buildMenu } from '@/components/controllers/MenuController.js'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'MenuView',
    components: {
        HeaderComponent,
        ProductModal,
        ProductGroupComponent
    },
    data () {
        return {
            searchText: '',
            groups: [],
            loading: false
        }
    },
    computed: {
        ...mapGetters(['menuRestaurants', 'currentRestaurant', 'restaurantGroups'])
    },
    methods: {
        filterItems: function () {
            // copia o array de grupos para não alterar o original
            this.groups = this.restaurantGroups.map(group => Object.assign({}, group))

            // se a pesquisa estiver vazia, fecha os grupos
            if (this.searchText === '') {
                this.groups.forEach(group => {
                    group.showProducts = false
                })
                return
            }

            this.groups.forEach(group => {
                group.products = group.products.filter(product => {
                    // remover acentos na pesquisa
                    const productName = product.NMPRODUTO.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                    const searchText = this.searchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                    return productName.toLowerCase().includes(searchText.toLowerCase())
                })
                group.isVisible = group.products.length > 0
                group.showProducts = true
            })
        },
        handleProductClick (product) {
            if (product.GRUPOS.length === 0) {
                this.showProductModal(product)
            } else {
                // se o produto tiver grupos, abre o modal de grupos
                this.showGroupsMenu(product)
            }
        },
        ...mapActions(['showProductModal', 'showGroupsMenu'])
    },
    created () {
        this.groups = this.restaurantGroups
        this.groups.forEach(group => {
            group.CODIGO = group.NRPGCONFTELA + group.NRBUTTON
            group.isVisible = true
            group.showProducts = false
        })

        this.loading = true

        buildMenu(
            this.currentRestaurant.CDCLIENTE,
            this.currentRestaurant.CDFILIAL,
            this.currentRestaurant.CDCAIXA,
            this.currentRestaurant.CDLOJA,
            this.currentRestaurant.NRCONFTELA,
            this.restaurantGroups
        ).then((res) => {
            this.loading = false
            // associa os produtos aos grupos pelo código
            res.forEach(menuItem => {
                const group = this.groups.find(group => group.CODIGO === menuItem.grupo.CODIGO)
                group.products = menuItem.produtos
            })
        })
    }
}
</script>

<style lang="less" scoped>
.menu-container {
    h1 {
        font-weight: 600;
    }

    .search {
        display: flex;
        align-items: center;
        margin-top: 30px;
        background-color: #d9d9d963;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px 10px;
        position: relative;
        margin-bottom: 10px;

        input {
            border: none;
            outline: none;
            background-color: transparent;
            font-size: 18px;
            font-family: Gellix;
            width: 100%;
        }

        i {
            position: absolute;
            right: 10px;
            color: gray;
        }
    }

    .list {
        height: calc(100vh - 170px);
        overflow-y: auto;

        &::-webkit-scrollbar {
            display: none;
        }

        .list-item {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            padding: 20px 10px;
            border-bottom: solid #BAB8B8 2px;

            &:last-of-type {
                margin-bottom: 20px;
            }
        }

        .products {
            display: flex;
            justify-content: space-between;
            margin-top: 15px;
            padding: 15px 10px;
            border: 1px solid rgba(0, 0, 0, 0.18);
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 5px;
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            h1 {
                font-weight: normal;
            }

            &:last-of-type {
                margin-bottom: 20px;
            }
        }

        .loading {
            margin-top: 20px;
            display: flex;
            justify-content: center;
        }
    }

    .slide-fade-enter-active, .slide-fade-leave-active {
        transition: all .1s linear;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
        transform: translateY(20px);
    }

    .not-found {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
}

</style>
